import React from "react";
import { Avatar, Tooltip, Typography } from "antd";
import { useTranslation } from "react-i18next";
import { ApartmentOutlined, UserOutlined } from "@ant-design/icons";
import "./TherapistSelectorBar.scss";

const { Text } = Typography;

export function TherapistSelectorBar({
  therapists = [],
  selectedId,
  onSelect,
  loading,
}) {
  const { t } = useTranslation("institution");

  // "all" es el valor para la vista Global
  const isGlobalSelected = selectedId === "all";

  return (
    <div className="revi-therapist-bar">
      {/* 1. OPCIÓN GLOBAL (CENTRO) */}
      <Tooltip title={t("dashboard.selector.globalTooltip")}>
        <div
          className={`revi-therapist-item ${isGlobalSelected ? "active" : ""}`}
          onClick={() => !loading && onSelect("all")}
        >
          <div className="revi-therapist-item__avatar-wrapper">
            <Avatar
              size={56}
              icon={<ApartmentOutlined />}
              className="revi-therapist-item__avatar global-avatar"
            />
          </div>
          <Text className="revi-therapist-item__name" strong={isGlobalSelected}>
            {t("dashboard.selector.global")}
          </Text>
        </div>
      </Tooltip>

      <div className="revi-therapist-bar__divider" />

      {/* 2. LISTA DE TERAPEUTAS */}
      <div className="revi-therapist-bar__list">
        {therapists.map((t) => {
          const isSelected = selectedId === t._id;
          const fullName = `${t.firstname} ${t.lastname || ""}`.trim();

          return (
            <Tooltip key={t._id} title={fullName}>
              <div
                className={`revi-therapist-item ${isSelected ? "active" : ""}`}
                onClick={() => !loading && onSelect(t._id)}
              >
                <div className="revi-therapist-item__avatar-wrapper">
                  <Avatar
                    size={56}
                    src={t.avatar}
                    icon={<UserOutlined />}
                    className="revi-therapist-item__avatar"
                  />
                </div>
                <Text
                  className="revi-therapist-item__name"
                  ellipsis
                  strong={isSelected}
                >
                  {t.firstname}
                </Text>
              </div>
            </Tooltip>
          );
        })}
      </div>
    </div>
  );
}
